import { render, staticRenderFns } from "./TiempoParosTurno.vue?vue&type=template&id=03ee5849&"
import script from "./TiempoParosTurno.vue?vue&type=script&lang=js&"
export * from "./TiempoParosTurno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports